import React from "react";

import "./_apps.scss";

import PopupApps, { popupApps } from "./PopupApps";

function Apps(props) {
	const textColor = (props.config === undefined) ? null : props.config[1].value;
	const backgroundColor = (props.config === undefined) ? null : props.config[0].value;
	const shadowColor = (props.config === undefined) ? null : props.config[2].value;
	const textLinksColor = (props.config === undefined) ? null : props.config[3].value;
	const clazz = (props.className) ? props.className : '';

	return (
		<div
			style={{ color: textColor, textShadow: "0 0 3px " + shadowColor }}
			className={"btn-apps " + clazz}
			onMouseEnter={() => popupApps("40px", "100px", "showApps")}
			onMouseLeave={() => popupApps("30px", "55px", "hiddenApps")}
		>
			Apps
			<PopupApps background={backgroundColor} shadow={shadowColor} text={textLinksColor} />
		</div>
	);
}

export default Apps;
